/* PSF home header transparency: listen to Horizon's scrollable .page-wrapper
   on desktop and the window on mobile; do not change the live Shopify theme. */
(() => {
  const apply = () => {
    document.querySelectorAll('.ce-editorial-header--home').forEach(header => {
      const wrapper = document.querySelector('.page-wrapper');
      const pos = Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, wrapper?.scrollTop || 0);
      header.classList.toggle('is-scrolled', pos > 16);
    });
  };
  const start = () => {
    document.querySelector('.page-wrapper')?.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('scroll', apply, { passive: true });
    document.addEventListener('shopify:section:load', apply);
    apply();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
